import $ from 'jquery';
import 'datatables.net-bs4';
import createBehavior from '../create-behavior';


export default () => {
    class CustomTable {
        constructor($el, context, settings) {
            $el.DataTable({
                sDom: 't',
                searching: false,
                info:false,
                paging: false
            });
        }
    }
    createBehavior('.data-table', 'CustomTable', CustomTable);
}



// WEBPACK FOOTER //
// ./js/src/behaviors/data-table.js